import React from "react";
import "../styles/ChecklistCard.css";
import Clause from "./LeaseClause";

export default function BCLeaseClauseCard({
  ClauseDataCommon,
  ClauseDataSituational,
  ClauseCardDescription,
  title,
}) {
  return (
    <div className="checklist-card checklist-card-modern">
      <div className="flex flex-wrap checklist-card-header">
        <div>{ClauseCardDescription[0].title}</div>
      </div>
      <div className="clause-card-content">
        <div
          className="clause-card-description"
          dangerouslySetInnerHTML={{
            __html: ClauseCardDescription[0].text,
          }}
        />

        {ClauseDataCommon.length === 0 ? (
          ""
        ) : (
          <h2 className="clause-section-title">{ClauseCardDescription[0].title}</h2>
        )}

        <ul className="clause-list">
          {ClauseDataCommon.map((item, index) => (
            <div key={index} className="clause-list-item">
              <Clause Clause={item} />
            </div>
          ))}
        </ul>

        {ClauseDataSituational.length === 0 ? (
          ""
        ) : (
          <h2 className="clause-section-title">Additional Tenancy Information</h2>
        )}

        <ul className="clause-list">
          {ClauseDataSituational.map((item, index) => (
            <div key={index} className="clause-list-item">
              <Clause Clause={item} />
            </div>
          ))}
        </ul>
      </div>
    </div>
  );
}
